import { controllerModel as model } from './model';
import { injectionSymbols } from './config';

export { BottomSheetPlugin, ModalPlugin } from './config';
export const controllerModel = {
  ...model,
  injectionSymbols,
};
